import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import TranslationNamespaces from '../../../localization/translation-namespaces';
import LoadingComponentProps from './loading-component-props';

export default function LoadingComponent({ spinnerText }: Readonly<LoadingComponentProps>) {
	const { t } = useTranslation(TranslationNamespaces.Root);

	return (
		<Box
			style={{
				width: '100%',
				height: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<CircularProgress />
				<Typography>{t(spinnerText ?? 'Loading')}</Typography>
			</Box>
		</Box>
	);
}
